import React from 'react';
import PropTypes from 'prop-types';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import OneSquare from './components/OneSquare';

const TwoSquares = ({ config: { squareBlock1 = {}, squareBlock2 = {} } }) => (
  <FixedWidthContainer
    className="min-h-[500px] flex flex-col md:flex-row"
    noMobilePadding
    noTabletPadding
  >
    <OneSquare config={squareBlock1} />
    <OneSquare config={squareBlock2} />
  </FixedWidthContainer>
);

TwoSquares.propTypes = {
  config: PropTypes.shape({
    squareBlock1: OneSquare.propTypes.config,
    squareBlock2: OneSquare.propTypes.config,
  }),
};

export default TwoSquares;
